module.exports = __webpack_public_path__ + "img/foto_seguridad.d16ddc84.jpg";